export default __webpack_public_path__ + "static/googleSignIn-b895e19c2c015a6894f9cc1cd5cce930.svg";